<template>
  <el-carousel
    class="outside_div"
    :autoplay="true"
    trigger="click"
    arrow="never"
    height="100%"
    ref="carousel"
  >
    <el-carousel-item v-for="(item, index) in List" :key="index">
      <v-touch
        :swipe-options="{ direction: 'horizontal' }"
        v-on:swipeleft="swiperright(index)"
        v-on:swiperight="swiperleft(index)"
        class="wrapper"
      >
        <div class="home_banner_div" @click="jumpTo(item.url)">
          <img :src="isMiniWindows ? item.phoneImg : item.img" />
          <div class="home_banner_txt_div">
            <p
              class="title_2"
              v-html="getLocalizedField(item, 'title')"
            ></p>
            <p
              class="title_1"
              v-html="getLocalizedField(item, 'content')"
            ></p>
          </div>
        </div>
      </v-touch>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import * as API from "@/api/index";
export default {
  data() {
    return {
      List: [],
      isMiniWindows: false,
      clientWidth: 0,
    };
  },
  created() {},
  watch: {
    clientWidth(newVal, oldVal) {
      // console.log(newVal); //浏览器窗口变化时，打印宽度。
      if (newVal < 1200) {
        this.isMiniWindows = true;
      } else {
        this.isMiniWindows = false;
      }
    },
    //监听轮播数据变化后再创建实例
    List() {
      this.$nextTick(() => {
        // this.playMultipleBanner();
      });
    },
  },
  computed: {},
  mounted() {
    this.getBannerList();
    let that = this;
    var clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
          document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  destroyed() {},
  methods: {
    // 获取多语言字段
    getLocalizedField(item, field) {
      if (!item) return '';
      if (this.$i18n.locale === 'zh') {
        return item[field];
      } else if (this.$i18n.locale === 'es') {
        return item[field + 'Es'] || item[field + 'En'] || item[field];
      }
      return item[field + 'En'] || item[field];
    },
    getBannerList() {
      API.getHomeBannerList({ page: 1, limit: 5 })
        .then((res) => {
          console.log('HomeBanner:', res);
          if (res.code === 0 && res.page && res.page.list) {
            // 映射后端数据到组件需要的格式
            this.List = res.page.list.map(item => ({
              img: item.image,
              phoneImg: item.imagePhone,
              title: item.titleCn,
              titleEn: item.titleEn || item.titleCn,
              titleEs: item.titleEs || item.titleEn || item.titleCn,
              content: item.contentCn,
              contentEn: item.contentEn || item.contentCn,
              contentEs: item.contentEs || item.contentEn || item.contentCn,
              url: item.linkUrl
            }));
          }
        })
        .catch(() => {});
    },
    jumpTo(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    navTo(path) {
      this.$router.push(path);
    },
    //设置滑动切换轮播图
    swiperleft: function (index) {
      //上一页
      this.$refs.carousel.prev();
      //设置幻灯片的索引
      this.$refs.carousel.setActiveItem(index - 1);
    },
    swiperright: function (index) {
      //下一页
      this.$refs.carousel.next();
      this.$refs.carousel.setActiveItem(index + 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}

.outside_div {
  height: 87rem;
  width: 100%;
  z-index: 0;

  /deep/.el-carousel__indicators--horizontal {
    bottom: 4rem;
    padding: 12px 20px;
    width: max-content;
  }

  /deep/.el-carousel__button {
    width: 1.3rem;
    border-radius: 50%;
    height: 1.3rem;
    margin: 0 0.8rem;
    opacity: 1;
    background-color: #BDC0C5;
  }

  /deep/.el-carousel__indicator.is-active button {
    background-color: #5B6370;
    width: 1.3rem;
    height: 1.3rem;
  }
}
/deep/ .el-carousel__arrow {
  &:hover {
    background-color: transparent;
  }
}
/deep/ .el-carousel__arrow--left {
  background-image: url("../../../static/img/banner_left_icon.png");
  background-size: contain;
  height: 6.5rem;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 3rem;
  border-radius: unset;
  left: 15rem;
  i {
    display: none;
  }
}
/deep/ .el-carousel__arrow--right {
  background-image: url("../../../static/img/banner_right_icon.png");
  background-size: contain;
  height: 6.5rem;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 3rem;
  border-radius: unset;
  right: 15rem;
  i {
    display: none;
  }
}

.home_banner_div {
  position: relative;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }



    .home_banner_txt_div {
    margin: 0 auto;
    max-width: 1920px;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 29.6%;
    padding-left: 12.55%;

    .title_1 {
      color: #E7E8EA;
      letter-spacing: 1px;
      text-align: left;
      font-size: 2.2rem;
      font-family: regular;
      max-width: calc(100% - 12.55% - 58.7%);
      line-height: 3rem;
    }

    .title_2 {
      color: #fff;
      text-align: left;
      font-size: 8rem;
      font-family: bold;
      margin-bottom: 2.66%;
      line-height: 1.1;
      max-width: calc(100% - 12.55% - 47.55%);
    }
  }
}

@media screen and (max-width: 1200px) {
  .home_banner_div {
    // img {
    // object-fit: contain;
    // }
    .home_banner_txt_div {
      width: 90%;
      top: 50%;
      padding-left: 2rem;

      .title_1 {
        color: white;
        line-height: 1.5;
        font-size: 1.6rem;
        text-align: left;
      }

      .title_2 {
        color: white;
        font-size: 3.2rem;
        line-height: 1.2;
        text-align: left;
      }
    }

    .more_touch_box_b_3E {
      font-size: 2.2rem;
      border: #1961ac solid 1px !important;
      border-radius: 5rem;
      padding: 1rem 4rem;
      width: fit-content;
      color: white;
      cursor: pointer;
      transition: all 0.5s;
      background-color: #1961ac !important;
    }
  }

  .outside_div {
    //height: 43.5rem !important;

    /deep/.el-carousel__indicators--horizontal {
      bottom: 2rem;
    }


    /deep/.el-carousel__button {
      width: 1rem;
      height: 1rem;
      margin: 0 1rem;
      // opacity: 1;
      // background-color: white;
    }

    /deep/.el-carousel__indicator.is-active button {
      // background-color: #1961ac;
      // width: 12.5rem;
    }
  }
  /deep/ .el-carousel__arrow {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  /deep/.el-carousel__button {
    width: 1rem !important;
    height: 1rem !important;
    margin: 0 1rem;
  }

  /deep/.el-carousel__indicator.is-active button {
    width: 1rem !important;
    height: 1rem !important;
  }
  .home_banner_div .home_banner_txt_div{
    .title_2{
      max-width: 100%;
    }
    .title_1{
      max-width: 100%;
      font-size: 1.1rem;
    }
  }
}
</style>
